import { kUsersPath } from '@/constants/constants-gcs'

export function isValidUserFolderPath(folderPath: string): boolean {
  if (!folderPath.startsWith(kUsersPath)) {
    return false
  }

  return true
}

export function extractUserIdFromPath(folderPath: string): string | null {
  if (!isValidUserFolderPath(folderPath)) {
    return null
  }

  const segments = folderPath.split('/').filter(Boolean)
  return segments[1] || null
}
